export default __webpack_public_path__ + "static/media/DSC03672.16d65929.jpg";